import CampaignContentGuidelines from './campaign_content_guidelines';

export default CampaignContentGuidelines;



// WEBPACK FOOTER //
// ./components/campaign_content_guidelines/index.js